export default "__VITE_ASSET__CQIq9Lum__"